import {isEdge} from '../helpers/Browser'

export function downloadArquivoAjax(url, onSucessDownloadBoleto, onErrorDownloadBoleto){
    var xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState === XMLHttpRequest.DONE ) {
           if (xmlhttp.status === 200) {
               onSucessDownloadBoleto && onSucessDownloadBoleto()
               window.location.assign(url)
           } else {
                onErrorDownloadBoleto && onErrorDownloadBoleto()
           }
        }
    };

    xmlhttp.open("GET", url, true);
    xmlhttp.send();
}

export function downloadArquivoAjaxComNotificacao(url, onSucessDownloadBoleto, onErrorDownloadBoleto, idHistorico){
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState === XMLHttpRequest.DONE ) {
           if (xmlhttp.status === 200) {
               window.location.assign(url)
               onSucessDownloadBoleto();
           } else {
               onErrorDownloadBoleto(idHistorico);
           }
        }
    };

    xmlhttp.open("GET", url, true);
    xmlhttp.send();
}

function getFileExtension(contentType){
    switch (contentType) {
        case "application/pdf":
            return ".pdf"
        case "application/xml":
            return ".xml"
        case "application/xls":
            return ".xls"
        case "text/csv": 
                return ".csv"
        default:
            return ""
        
    }
    
}

function downloadEdge(data, titulo, contentType="application/pdf"){
    let blobObject = b64toBlob(data, contentType)
    window.navigator.msSaveBlob(blobObject, titulo);
}

export function downloadFileLink(data, titulo = "arquivo", contentType="application/pdf"){
    
    if(isEdge()){
        downloadEdge(data, titulo + getFileExtension(contentType), contentType)
    } else {
        let link = document.createElement("a")
        link.setAttribute('href', `data:${contentType};base64,${data}`)
        link.setAttribute('download', titulo + getFileExtension(contentType))
        
        link.style.display = 'none';
        document.body.appendChild(link);
        
        link.click();
        
        document.body.removeChild(link);
    }

    

}

export function downloadBytesLink(data, titulo = "arquivo", contentType="application/pdf"){
    let blob = new Blob([data], {type: contentType});
    // let link = document.createElement("a");
    // link.href = window.URL.createObjectURL(blob);
    // link.download = titulo;
    // link.click();

    let link = document.createElement("a")
    link.setAttribute('href', window.URL.createObjectURL(blob))
    link.setAttribute('download', titulo + getFileExtension(contentType))

    link.style.display = 'none';
    document.body.appendChild(link);
    
    link.click();

    document.body.removeChild(link);
}
// window.location.assign(path)

export function b64toBlob(b64Data, contentType='application/pdf', sliceSize=512){
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
}


// WEBPACK FOOTER //
// ./src/helpers/Downloads.js